import {NgModule} from '@angular/core';
import {EventLogService} from './eventLog.service';
import {CommandFactory} from './CommandFactory';
import {ObjectTransformationFactory} from './common/ObjectTransformation';

@NgModule({
  providers: [
    EventLogService,
    CommandFactory,
    ObjectTransformationFactory
  ]
})
export class EventLogModule {
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/Module.ts